/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import React from "react";
import Head from "next/head";
import Header from "../../../common/header/Header";
import Footer from "../../../common/footer/Footer";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      h2: "h2",
      ul: "ul",
      li: "li",
      em: "em"
    }, props.components);
    return _jsxs("main", {
      className: "page-wrapper",
      children: [_jsx(Head, {
        children: _jsx("title", {
          children: "Modulabs | Refund policy"
        })
      }), _jsx(Header, {
        className: "header-not-transparent"
      }), _jsx("div", {
        className: "post-page-banner rn-section-gapTop",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content text-center",
                children: _jsx("div", {
                  className: "page-title",
                  children: _jsx("h1", {
                    className: "theme-gradient",
                    children: "Refund policy"
                  })
                })
              })
            })
          })
        })
      }), _jsx("div", {
        className: "blog-details-content pt--60 rn-section-gapBottom",
        children: _jsx("div", {
          className: "container",
          children: _jsx("div", {
            className: "row",
            children: _jsx("div", {
              className: "col-lg-8 offset-lg-2",
              children: _jsx("div", {
                className: "content",
                children: _jsxs("div", {
                  children: [_jsx(_components.h1, {
                    children: "A fair refund policy."
                  }), _jsxs(_components.p, {
                    children: ["Bad refund policies are infuriating. You feel like the company is just trying to rip you\noff. We never want our customers to feel that way, so our refund policy is simple: If you’re\never unhappy with our products* for any reason, just contact ", _jsx(_components.a, {
                      href: "mailto:support@modulabs.io",
                      children: "our support\nteam"
                    }), " and we'll take care of you."]
                  }), _jsx(_components.h2, {
                    children: "Examples of full refunds we’d grant."
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "If you were just charged for your next month of service but you meant to cancel, we’re\nhappy to refund that extra charge."
                    }), "\n", _jsx(_components.li, {
                      children: "If you forgot to cancel your account a couple months ago and you haven’t used it since\nthen, we’ll give you a full refund for a few back months. No problem."
                    }), "\n", _jsx(_components.li, {
                      children: "If you tried one of our products for a couple months and you just weren’t happy with it,\nyou can have your money back."
                    }), "\n"]
                  }), _jsx(_components.h2, {
                    children: "Examples of partial refunds or credits we’d grant."
                  }), _jsxs(_components.ul, {
                    children: ["\n", _jsx(_components.li, {
                      children: "If you forgot to cancel your account a year ago, and there’s been activity on your account\nsince then, we’ll review your account usage and figure out a partial refund based on how\nmany months you used it."
                    }), "\n", _jsx(_components.li, {
                      children: "If you upgraded your account a few months ago to a higher plan and kept using it in\ngeneral but you didn’t end up using the extra features, projects, or storage space, we’d\nconsider applying a prorated credit towards future months."
                    }), "\n", _jsx(_components.li, {
                      children: "If we had extended downtime (multiple hours in a day, or multiple days in a month) or you\nemailed customer service and it took multiple days to get back to you, we’d issue a partial\ncredit to your account."
                    }), "\n"]
                  }), _jsx(_components.h2, {
                    children: "Get in touch"
                  }), _jsxs(_components.p, {
                    children: ["At the end of the day, nearly everything on the edges comes down to a case-by-case basis.\n", _jsx(_components.a, {
                      href: "mailto:support@modulabs.io",
                      children: "Send us a note"
                    }), ", tell us what's up, and we'll work with you to make\nsure you’re happy."]
                  }), _jsxs(_components.p, {
                    children: ["*", _jsx(_components.em, {
                      children: "This policy applies to any product created and owned by Modulabs, LLC."
                    })]
                  }), _jsxs(_components.p, {
                    children: ["Adapted from the ", _jsx(_components.a, {
                      href: "https://github.com/basecamp/policies",
                      children: "Basecamp open-source policies"
                    }), " / ", _jsx(_components.a, {
                      href: "https://creativecommons.org/licenses/by/4.0/",
                      children: "CC\nBY 4.0"
                    })]
                  })]
                })
              })
            })
          })
        })
      }), _jsx(Footer, {})]
    });
  }
}
export default MDXContent;
